import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Box from '../Box';
import useMenuItem from './useMenuItem';

const MenuItem = forwardRef(({
  children,
  active,
  highlighted,
  iconBefore,
  iconAfter,
  onClick,
  style, // don't forward
  className, // don't forward
  ...rest
}: any, ref?: any) => {
  const {
    classNames,
    IconBefore,
    IconAfter,
    Content,
  } = useMenuItem({
    active,
    highlighted,
    iconBefore,
    iconAfter,
  });

  return (
    <Box
      element="button"
      display="flex"
      alignItems="center"
      className={classNames}
      innerRef={ref}
      {...rest}
      onClick={(...args: any[]) => {
        if (typeof onClick === 'function') onClick(...args);
      }}
    >
      <IconBefore />
      <Content>
        { children }
      </Content>
      <IconAfter />
    </Box>
  );
}) as any;

(MenuItem as any).propTypes = {
  /**
    * The text for this menu item
    */
  children: PropTypes.node.isRequired,
  /**
    * Whether or not to display this item as active
    */
  active: PropTypes.bool,
  /**
    * An <Icon /> to show on the right of the item
    */
  iconAfter: PropTypes.node,
  /**
    * An <Icon /> to show on the left of the item
    */
  iconBefore: PropTypes.node,
};

(MenuItem as any).defaultProps = {};

(MenuItem as any).displayName = 'MenuItem';

export default MenuItem;
